import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  EstimateApplianceInput,
  RemoveEstimateApplianceMutation as RemoveEstimateApplianceMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const RemoveEstimateApplianceMutation = graphql(`
  mutation RemoveEstimateAppliance($input: EstimateApplianceInput!) {
    removeEstimateAppliance(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

const useRemoveEstimateAppliance = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    RemoveEstimateApplianceMutationResult,
    Error,
    EstimateApplianceInput
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    RemoveEstimateApplianceMutationResult,
    Error,
    EstimateApplianceInput
  >({
    mutationFn: (input) =>
      gqlClient.request(RemoveEstimateApplianceMutation, { input }),
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.removeEstimateAppliance,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useRemoveEstimateAppliance;
